<template>
  <div class="resident-list">
    <section class="list-header">
      <div class="title-row">
        <v-btn icon class="back-button" @click="$router.push('/home')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>Votações</h1>
      </div>
      <v-btn icon class="refresh-button" @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </section>

    <section v-if="!items.length && !loading" class="empty-panel">
      <v-icon color="primary" size="36">mdi-poll</v-icon>
      <strong>Nenhuma votação aberta</strong>
      <span>Quando houver decisões consultivas, elas aparecerão aqui.</span>
    </section>

    <article v-for="poll in items" :key="poll.id" class="poll-card">
      <div class="poll-heading">
        <div>
          <strong>{{ poll.title }}</strong>
          <span>{{ poll.description || "Escolha uma opção para registrar sua participação." }}</span>
        </div>
        <v-chip x-small color="secondary" text-color="primary">{{ poll.status }}</v-chip>
      </div>

      <v-radio-group v-model="votes[poll.id]" class="mt-2">
        <v-radio v-for="option in poll.options || []" :key="option.id" :label="option.label" :value="option.id" />
      </v-radio-group>

      <v-btn block depressed color="primary" :loading="savingId === poll.id" @click="vote(poll)">
        Registrar voto
      </v-btn>
    </article>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoaruaPolls",
  data() {
    return {
      loading: false,
      savingId: null,
      items: [],
      votes: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const profile = JSON.parse(localStorage.getItem("associationProfile") || "{}");
      this.loading = true;
      try {
        const response = await axios.get("/polls", {
          params: { tenant_id: profile.tenant_id, limit: 50, search: JSON.stringify({ status: "open" }) },
        });
        this.items = response.data.content.data || response.data.content || [];
      } finally {
        this.loading = false;
      }
    },
    async vote(poll) {
      const optionId = this.votes[poll.id] || (poll.options && poll.options[0] && poll.options[0].id);
      if (!optionId) return;
      this.savingId = poll.id;
      try {
        await axios.post(`/polls/${poll.id}/vote`, { poll_option_id: optionId });
        this.$dialog && this.$dialog.notify && this.$dialog.notify.success("Voto registrado", { position: "top-right", timeout: 3000 });
      } finally {
        this.savingId = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.resident-list {
  min-height: 100%;
  padding: 0 16px 18px;
  color: #111827;
}

.list-header {
  min-height: 72px;
  margin: 0 -16px 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-bottom: 1px solid #edf0ed;

  h1 {
    margin: 0;
    font-size: 24px;
  }
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-button,
.refresh-button {
  background: #f5f7f5;
  border: 1px solid #dfe7df;
  border-radius: 12px;
}

.poll-card,
.empty-panel {
  background: #ffffff;
  border: 1px solid #e1e8e2;
  border-radius: 16px;
}

.poll-card {
  margin-bottom: 10px;
  padding: 14px;
}

.poll-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  strong,
  span {
    display: block;
  }

  span {
    margin-top: 4px;
    color: #66736b;
    font-size: 13px;
  }
}

.empty-panel {
  min-height: calc(100vh - 184px);
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-align: center;

  span {
    color: #66736b;
    font-size: 13px;
  }
}
</style>
